import { Form } from 'react-bootstrap';

const Sapibp = ({ state, onChange }: any) => {
  const { templateName = '', jobUser = '', jobText = '' } = state.config || {};

  return (
    <>
      <Form.Group className="mb-2 w-full" controlId="formNode-templateName">
        <Form.Label>Template name (optional)</Form.Label>
        <Form.Control type="text" name="templateName" value={templateName} onChange={(e) => onChange(e, true)} placeholder="e.g. MyTemplate" />
      </Form.Group>

      <Form.Group className="mb-2 w-full" controlId="formNode-jobUser">
        <Form.Label>
          User<span className="text-danger"> *</span>
        </Form.Label>
        <Form.Control type="text" name="jobUser" value={jobUser} onChange={(e) => onChange(e, true)} required placeholder="Enter job user" />
      </Form.Group>

      <Form.Group className="mb-2 w-full" controlId="formNode-jobText">
        <Form.Label>
          Job Text<span className="text-danger"> *</span>
        </Form.Label>
        <Form.Control type="text" name="jobText" value={jobText} onChange={(e) => onChange(e, true)} required placeholder="Describe the job" />
      </Form.Group>
    </>
  );
};

export default Sapibp;
